module.exports = __webpack_public_path__ + "images/admin/settings-dealstages.png";